export const InternCompanyFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}

function header(form_data) {
  return [
    {
      w: '100%', h: 50, text: '國立臺灣科技大學\n實習機構評估表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    {
      w: '100%', h: 30, text: '系所名稱：' + form_data.department_ofs_id,
      border_width: 0,  align: 'left' ,font_family: '標楷體',
    },

    {
      w: '100%', h: 30, text: '一、實習工作概況',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '公司名稱' },
    { w: '82%', h: 30, text: form_data.enterprise_name },

    { w: '18%', h: 30, text: '聯絡人' },
    { w: '32%', h: 30, text: form_data.contact_person },
    { w: '18%', h: 30, text: '職稱' },
    { w: '32%', h: 30, text: form_data.company_role },

    { w: '18%', h: 30, text: '聯絡電話' },
    { w: '32%', h: 30, text: form_data.contact_tel },
    { w: '18%', h: 30, text: '傳真' },
    { w: '32%', h: 30, text: form_data.fax },

    { w: '18%', h: 30, text: '工作內容' },
    { w: '82%', h: 30, text: form_data.work_content },
    { w: '18%', h: 30, text: '需求條件或專長' },
    { w: '82%', h: 30, text: form_data.work_requirment },

    { w: '18%', h: 50, text: '輪班' },
    { w: '32%', h: 50, texts: [
      ...form_data.shift_status,
      `工作 ${form_data.work_time} 時，做 ${form_data.work_days} 天，休 ${form_data.rest_days} 天。`
    ]},
    { w: '18%', h: 50, text: '系別' },
    { w: '32%', h: 50, text: form_data.department_id },

    { w: '18%', h: 30, text: '工作時間' },
    { w: '32%', h: 30, text: `每週 ${form_data.work_hour} 時` },
    { w: '18%', h: 30, text: '住宿' },
    { w: '32%', h: 30, texts: form_data.provide_stay },

    { w: '18%', h: 50, text: '加班時間' },
    { w: '32%', h: 50, text: `每日 ${form_data.ot_daily} 時，每週 ${form_data.ot_weekly} 時` },
    { w: '18%', h: 50, text: '提供薪資額度' },
    { w: '32%', h: 50, text: form_data.salary },

    { w: '18%', h: 30, text: '勞健保' },
    { w: '32%', h: 30, texts: form_data.health_insurance },
    { w: '18%', h: 30, text: '膳食' },
    { w: '32%', h: 30, texts: form_data.provide_meal },

    { w: '18%', h: 30, text: '提撥勞退基金' },
    { w: '32%', h: 30, texts: form_data.labor_pension },
    { w: '18%', h: 30, text: '配合簽約' },
    { w: '32%', h: 30, texts: form_data.sign_contract },

    {
      w: '100%', h: 30, text: '二、實習工作評估',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '評估時間' },
    { w: '82%', h: 30, text: date_to_str(form_data.mark_date) },
    { w: '100%', h: 30, padding: 10, align: 'right', text: '(極佳: 5, 佳: 4, 可: 3, 不佳: 2, 極不佳: 1)' },
    ...check_radio_table(blueprint.find(block => block.key == 'check').items, form_data.check),

    { w: '18%', h: 30, text: '評估總分' },
    { w: '82%', h: 30, text: form_data.check_mark + ' 分 (滿分35分)' },

    {
      w: '100%', h: 30, text: '三、實習機會',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { w: '100%', h: 30, texts: [
      `${form_data.company_apply} 廠商申請`,
      `${form_data.teacher_apply} ${form_data.teacher_apply_name || '________'} 老師推介`,
      `${form_data.student_apply} ${form_data.student_apply_name || '________'} 學生申請`,
      `${form_data.other_apply} 其他 ${form_data.other_apply_name || '________'}`,
    ]},

    {
      w: '100%', h: 30, text: '四、補充說明',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    {
      w: '100%', h: 16, text: '(請與實習機構確認務依實習合作契約期間提供實習機會，勿因公司營運因素而期中解約造成學生中斷實習之困擾。)',
      border_width: 0, align: 'left', font_size: 14, font_family: '標楷體',
    },
    { w: '100%', h: 10, border_width: 0 },
    { w: '100%', h: 100, padding: 10, align: 'left', baseline: 'top', text: form_data.sup_explaination },

    {
      w: '100%', h: 30, text: '五、評估結論',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    {
      w: '100%', h: 16, text: '(評估結論如為「推薦實習」，請於正式簽約後，此表連同合約書影送就輔組備查。)',
      border_width: 0, align: 'left', font_size: 14, font_family: '標楷體',
    },
    { w: '100%', h: 10, border_width: 0 },
    { w: '100%', h: 30, texts: form_data.recommendation },

    { w: '100%', h: 30, align: 'left', border_width: 0, text: '單位主管：' + form_data.dept_manager },
  ];
}

function check_radio_table(items, values) {
  return items.map((item, index) => {
    return [
      { w: '70%', h: 30, padding: 10, align: 'left', text: item },
      { w: '30%', h: 30, padding: 10, texts: values[index] },
    ];
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}